/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gt_ExperiencesInputs */

const en_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiences`)
};

const ar_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخبرات`)
};

const bn_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অভিজ্ঞতা`)
};

const de_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrungen`)
};

const es_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencias`)
};

const fr_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expériences`)
};

const pt_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiências`)
};

const zh_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经验`)
};

const tr_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneyimler`)
};

const ru_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опыт`)
};

const pl_gt_experiences = /** @type {(inputs: Gt_ExperiencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doświadczenia`)
};

/**
* | output |
* | --- |
* | "Experiences" |
*
* @param {Gt_ExperiencesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const gt_experiences = /** @type {((inputs?: Gt_ExperiencesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gt_ExperiencesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_gt_experiences(inputs)
	if (locale === "bn") return bn_gt_experiences(inputs)
	if (locale === "de") return de_gt_experiences(inputs)
	if (locale === "es") return es_gt_experiences(inputs)
	if (locale === "fr") return fr_gt_experiences(inputs)
	if (locale === "pt") return pt_gt_experiences(inputs)
	if (locale === "zh") return zh_gt_experiences(inputs)
	if (locale === "tr") return tr_gt_experiences(inputs)
	if (locale === "ru") return ru_gt_experiences(inputs)
	if (locale === "pl") return pl_gt_experiences(inputs)
	return en_gt_experiences(inputs)
});